module.exports = __webpack_public_path__ + "static/media/mc_remove_rotor_icon.eb5d64fb.svg";